import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-links">
        <div className="footer-column">
          <h3>Shop by Category</h3>
          <div className="title-underline"></div>
          <ul>
            <li>
              <Link to="/shop" onClick={toTop}>
                All Products
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Customer Care</h3>
          <div className="title-underline"></div>
          <ul>
            <li>
              <Link to="/shipping" onClick={toTop}>
                Delivery Policy
              </Link>
            </li>
            <li>
              <Link to="/returns" onClick={toTop}>
                Returns & Refunds
              </Link>
            </li>
            <li>
              <Link to="/order-policy" onClick={toTop}>
                Orders & Cancellations
              </Link>
            </li>
            <li>
              <Link to="/payment-policy" onClick={toTop}>
                Payment & Billing
              </Link>
            </li>
            <li>
              <Link to="/warranty" onClick={toTop}>
                Product Warranty
              </Link>
            </li>
            <li>
              <Link to="/product-safety" onClick={toTop}>
                Product Safety
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h3>Privacy & Legal</h3>
          <div className="title-underline"></div>
          <ul>
            <li>
              <Link to="/terms" onClick={toTop}>
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/privacy" onClick={toTop}>
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/cookies" onClick={toTop}>
                Cookie Policy
              </Link>
            </li>
            <li>
              <Link to="/state-privacy" onClick={toTop}>
                U.S. Privacy Rights
              </Link>
            </li>
            <li>
              <Link to="/acceptable-use" onClick={toTop}>
                Acceptable Use
              </Link>
            </li>
            <li>
              <Link to="/intellectual-property" onClick={toTop}>
                Intellectual Property
              </Link>
            </li>
            <li>
              <Link to="/accessibility" onClick={toTop}>
                Accessibility
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h3>Company</h3>
          <div className="title-underline"></div>
          <ul>
            <li>
              <Link to="/about" onClick={toTop}>
                About Pawluna
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={toTop}>
                Contact Us
              </Link>
            </li>
            <li>
              <Link to="/faqs" onClick={toTop}>
                FAQs
              </Link>
            </li>
            <li>
              <Link to="/ethical-sourcing" onClick={toTop}>
                Ethical Sourcing
              </Link>
            </li>
            <li>
              <Link to="/sustainability" onClick={toTop}>
                Sustainability
              </Link>
            </li>
            <li>
              <Link to="/ai-data-processing" onClick={toTop}>
                AI & Data Processing
              </Link>
            </li>
            <li>
              <Link to="/policies" onClick={toTop}>
                All Policies
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-column address-column">
          <h3>Pawluna</h3>
          <div className="title-underline"></div>
          <p>
            many@pawluna.art
            <br />
            60 Harris Rd, Mineral Bluff, GA 30559 US
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="copyright">
          © 2025-2026 Copyright Pawluna. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
